import baseApi from '../api/baseApi';
import { buildApiPayload } from '../utils/api';

const exportApi = baseApi.injectEndpoints({
  endpoints: builder => ({
    exportReport: builder.query({
      query: data => ({
        url: '/analytic/report',
        method: 'GET',
        data: buildApiPayload({ payload: data, dateEndKeys: ['endTime'] }),
      }),
    }),
    downloadReport: builder.query({
      query: jobId => ({
        url: `/analytic/report/download/${jobId}`,
        method: 'GET',
        responseType: 'arraybuffer',
        returnHeaders: true,
      }),
      transformResponse: (baseQueryReturnValue, meta) => {
        return {
          report: baseQueryReturnValue,
          headers: meta.headers,
        };
      }
    }),
  }),
});

export default exportApi;
